import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCrown } from "@fortawesome/free-solid-svg-icons";
import styles from "./PlusBadge.module.css";

/**
 * Selo de status "Plus" (coroa) pra sobrepor no canto de QUALQUER avatar —
 * ranking, chat, perfil, etc. Diferente dos badges faCoins que marcam
 * FEATURES gateadas por Plus (ver btnSheetPlusBadge em Dashboard.module.css):
 * este marca que o usuário DONO do avatar já É assinante Plus.
 *
 * Uso: envolva o avatar num container com position:relative (display:inline-flex)
 * e renderize <PlusBadge /> como filho condicionalmente, ex.:
 *
 *   <span style={{ position: "relative", display: "inline-flex" }}>
 *     <img ... />
 *     {isPlus && <PlusBadge />}
 *   </span>
 */
export default function PlusBadge({ size = 16, title = "Assinante Plus" }) {
  const fontSize = Math.max(8, Math.round(size * 0.55));
  return (
    <span
      className={styles.badge}
      style={{ width: size, height: size, fontSize }}
      title={title}
    >
      <FontAwesomeIcon icon={faCrown} />
    </span>
  );
}
